import { makeRequest } from './https';
import {
  EmployeeCreateRequest,
  EmployeePatchRequest,
  GoogleDisconnectResponse,
  ReinviteRequest,
  ReinviteResponse,
} from '../types/employee.type';

export const getEmployees = (page = 1, limit = 100) =>
  makeRequest({ url: '/employees', method: 'get', params: { page, limit } });

export const createEmployee = (data: EmployeeCreateRequest) =>
  makeRequest({ url: '/employees', method: 'post', data });

export const updateEmployee = (id: string, data: EmployeeCreateRequest) =>
  makeRequest({ url: `/employees/${id}`, method: 'put', data });

export const patchEmployee = (id: string, data: EmployeePatchRequest) =>
  makeRequest({ url: `/employees/${id}`, method: 'patch', data });

export const deleteEmployee = (id: string) =>
  makeRequest({ url: `/employees/${id}`, method: 'delete' });

export const disconnectEmployeeGoogle = (id: string) =>
  makeRequest({ url: `/employees/${id}/google/disconnect`, method: 'delete' }) as Promise<GoogleDisconnectResponse>;

export const reinviteEmployee = (id: string, data: ReinviteRequest = {}) =>
  makeRequest({ url: `/employees/${id}/reinvite`, method: 'post', data }) as Promise<ReinviteResponse>;
